'use client';

import { CheckCaV2Result as CheckCaResult } from '@/types';
import { atom } from 'jotai';

export const caCheckAtom = atom<CheckCaResult | undefined>(undefined);

export const caAtom = atom<string>('');
